import { Select } from 'antd';
import React, { FC, useEffect } from 'react';
import { SelectProps } from 'antd/lib/select';

import { getAccounts } from '~/api/accounts';
import { useApi } from '~/hooks';
import { Account } from '~/types';

const { Option } = Select;

interface Props extends SelectProps<any> {
  fn?: (account: Account) => any;
  defaultSelectedFirstOption?: boolean;
  allowClear?: boolean;
}

const AccountInput: FC<Props> = (props) => {
  const {
    fn,
    defaultSelectedFirstOption = false,
    onChange,
    value,
    allowClear = false,
    ...rest
  } = props;
  const [{ data, loading }] = useApi<Account[]>(getAccounts);

  useEffect(() => {
    if (defaultSelectedFirstOption && data && data[0].id && onChange && !value) {
      onChange(
        data[0].id,
        data.map((item) => ({ value: item.id, label: item.number }))
      );
    }
  }, [data, defaultSelectedFirstOption, onChange, value]);

  if (!data && defaultSelectedFirstOption) return null;
  return (
    <Select
      loading={loading}
      defaultValue={defaultSelectedFirstOption ? data && data[0].id : undefined}
      onChange={onChange}
      value={data ? value : undefined}
      allowClear={allowClear}
      {...rest}
    >
      {data?.map((item) => {
        const accountNumber = item.number;
        return (
          <Option key={item.id} value={item.id}>
            {fn ? fn(item) : accountNumber}
          </Option>
        );
      })}
    </Select>
  );
};

export default AccountInput;
